import BrutalNavbar from './components/BrutalNavbar';
import BrutalGrid from './components/BrutalGrid';
import BrutalFooter from './components/BrutalFooter';
import ScrollReveal from '@/components/feature/ScrollReveal';
import { useState, useEffect } from 'react';

const HERO_TEXT = 'NOVA AI DIGITAL';
const SUBTITLE = "Browse our curated collection of world-class templates — select one and own it, have us build your site using a style you love, or bring us your vision and we'll craft something entirely your own.";

function TypewriterText({ text, delay = 0, className = '', style = {} }: {
  text: string;
  delay?: number;
  className?: string;
  style?: React.CSSProperties;
}) {
  const [displayed, setDisplayed] = useState('');
  const [started, setStarted] = useState(false);

  useEffect(() => {
    const startTimer = setTimeout(() => setStarted(true), delay);
    return () => clearTimeout(startTimer);
  }, [delay]);

  useEffect(() => {
    if (!started) return;
    if (displayed.length >= text.length) return;
    const id = setTimeout(() => {
      setDisplayed(text.slice(0, displayed.length + 1));
    }, 38);
    return () => clearTimeout(id);
  }, [started, displayed, text]);

  return (
    <span className={className} style={style}>
      {displayed}
      {displayed.length < text.length && (
        <span
          className="inline-block w-[3px] ml-1 align-middle bg-white/70"
          style={{ height: '0.85em', animation: 'blink-cursor 0.7s step-end infinite' }}
        />
      )}
    </span>
  );
}

export default function BrutalPage() {
  return (
    <div className="bg-white min-h-screen" style={{ fontFamily: "'Inter', sans-serif" }}>
      <style>{`
        @keyframes blink-cursor {
          0%, 100% { opacity: 1; }
          50% { opacity: 0; }
        }
      `}</style>

      <BrutalNavbar />

      {/* Hero header */}
      <div className="w-full bg-orange-600 px-6 pt-10 pb-8 text-center">
        <h1
          className="text-white font-black leading-none tracking-tight"
          style={{
            fontFamily: "'Inter', sans-serif",
            fontSize: 'clamp(48px, 10vw, 130px)',
            letterSpacing: '-0.04em',
            lineHeight: 1,
            minHeight: '1em',
          }}
        >
          <TypewriterText text={HERO_TEXT} delay={200} />
        </h1>
        <p
          className="text-white/80 font-normal mt-4 text-base md:text-lg leading-relaxed max-w-2xl mx-auto"
          style={{ fontFamily: "'Inter', sans-serif", minHeight: '3em' }}
        >
          <TypewriterText text={SUBTITLE} delay={800} />
        </p>
      </div>

      {/* Grid with filters */}
      <BrutalGrid />

      {/* Footer */}
      <BrutalFooter />
    </div>
  );
}
